import React, { useEffect , useState} from 'react'

const DynamicDataValue = (props) => {
    
const [updatedStatus,setUpdatedStatus] = useState({
    backgroundColor:"", statusCode: "",count:0
})


    useEffect(() => {
        switch(props.currentStatus){
            case 1:
                setUpdatedStatus( {backgroundColor : "#ffa500",status : "Pending",color:"#fff",count:props.count})
                
                break;
            case 2:
                setUpdatedStatus({ backgroundColor : "#C82333",status : "Rejected",color:"#fff",count:props.count})
                break;
            case 3:
                setUpdatedStatus({ backgroundColor : "#ffff00",status : "On hold",color:"#000",count:props.count})
                break;
            case 4:
                setUpdatedStatus({ backgroundColor : "#800080",status : "Under Review",color:"#fff",count:props.count})
              
                break;
            case 5:
                setUpdatedStatus({ backgroundColor : "#218838",status : "Approved",color:"#fff",count:props.count})
                break;
            case "active":
                setUpdatedStatus({ backgroundColor : "#218838",status : "active",color:"#fff",count:props.count})
                break;
                case "created":
                    setUpdatedStatus({ backgroundColor : "#ffa500",status : "created",color:"#fff",count:props.count})
                    break;
            case "cancelled":
                setUpdatedStatus({ backgroundColor : "#C82333",status : "cancelled",color:"#fff",count:props.count})
                break;
            case "expired":
                setUpdatedStatus({ backgroundColor : "#C82333",status : "expired",color:"#fff",count:props.count})
                break;
            case "authenticated":
                setUpdatedStatus({ backgroundColor : "#5BC0DE",status : "authenticated",color:"#fff",count:props.count})
                break;
                case "success":
                case "Success":
                    setUpdatedStatus({ backgroundColor : "#218838",status : "success",color:"#fff",count:props.count})
                    break;
                case "failed":
                setUpdatedStatus({ backgroundColor : "#C82333",status : "failed",color:"#fff",count:props.count?props.count:""})
                break;
                case "undefined":
                    setUpdatedStatus({ backgroundColor : "#C82333",status : "No status",color:"#fff",count:props.count})
                    break;
           
            case 6: //custom
                setUpdatedStatus({ backgroundColor : props.backgroundColor,status :props.status, color:"#fff",count:props.count})
                break;

                default:
                break;
        }
    },[props])

  return (
    <>
    <div style={{display:"flex",justifyContent:`${props.showAlignment ?"left":"center"}` ,cursor:"pointer"}} onClick={props.onClick}>
    <p disabled={props.disabled} style={{backgroundColor:updatedStatus.backgroundColor,color:updatedStatus.color,borderRadius:"10px",maxWidth:"140px",minWidth:"100px",textAlign:"center"}} className="currentstatus">
         {updatedStatus.status}{updatedStatus.count? - updatedStatus.count:""}
        </p>
    </div>
    </>
  )
}

export default DynamicDataValue